var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 14-2-2 2-2 2 2zM9.875 8.125l-2.5-2.5L12 1l4.625 4.625-2.5 2.5L12 6zm-4.25 8.5L1 12l4.625-4.625 2.5 2.5L6 12l2.125 2.125zm12.75 0-2.5-2.5L18 12l-2.125-2.125 2.5-2.5L23 12zM12 23l-4.625-4.625 2.5-2.5L12 18l2.125-2.125 2.5 2.5z"
  })));
};
export default SvgData;